(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video_grid"]) return;
  try {
    
  $(document).on('click', '.video-thumbnail', function() {
  var videoId = $(this).data('video');
  var videoUrl = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';

  // Display the video in a modal window
  var modalHtml = '<div class="video-modal">' +
                  '<iframe src="' + videoUrl + '" frameborder="0" allow="autoplay; fullscreen"></iframe>' +
                  '</div>';
  $('body').append(modalHtml);

  // Display the video in an embedded player
  var playerHtml = '<div class="video-player">' +
                   '<iframe src="' + videoUrl + '" frameborder="0" allow="autoplay; fullscreen"></iframe>' +
                   '</div>';
  $('.video-player-container').html(playerHtml);
});

  } catch(e) { console.error(e); }
})();
})();
